import request from "@utils/request"

export function getShipOrderList(data) {
    return request({
        url: '/service/mg/warehouse-management/delivery-list',
        method: 'POST',
        data,
    })
}

export function postDeliveryDetails(data) {
    return request({
        url: '/service/mg/warehouse-management/delivery-details',
        method: 'POST',
        data,
    })
}

export function postPurchaserInfo(data) {
    return request({
        url: '/service/mg/warehouse-management/delivery-details/purchaserInfo',
        method: 'POST',
        data,
    })
}

export function postFinalPayment(data) {
    return request({
        url: '/service/mg/warehouse-management/delivery-details/finalPayment',
        method: 'POST',
        data,
    })
}
